export default __webpack_public_path__ + "static/media/6-Life_science_workshop-GlyGen-2018.03.05.3b7b17ff.pdf";